// PRODUCT-26110 Task 8b Step 2: no longer installs PortalVue -- Modal.vue/
// ModalTarget.vue were migrated to native <Teleport>, which needs no plugin
// registration at all.
//
// PRODUCT-26110 Task 14: previously installed via the legacy
// `(this.options.Vue as any).use(...)` global singleton (only worked because
// @vue/compat's runtime provided one) -- now a real Vue 3 `Plugin`
// (`install(app: App)`), applied via `installAppPlugins()` in
// `application/Application.ts` against the actual `createApp()` instance.
import type { App } from 'vue';

import ModalManager from './ModalManager';

function createModalPlugin(): { install(app: App): void } {
    return {
        install(app: App): void {
            app.mixin({
                beforeCreate() {
                    if (this === this.$root) {
                        Object.defineProperty(this, '$modalManager', {
                            value: new ModalManager(),
                        });
                    } else {
                        Object.defineProperty(this, '$modalManager', {
                            get() {
                                return this.$root.$modalManager;
                            },
                        });
                    }
                },
            });
        },
    };
}

export default createModalPlugin;
